import React from 'react'
import { AppointmentBookingHours } from '@modmd/data'
import { RouteComponentProps } from 'react-router-dom'
import { ROUTES } from 'internal-portal/constants/routes'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import { Container } from 'components/Layout'
import Card from 'components/Card'
import { RequestTestSession as RequestGroupTestSession } from 'sharedComponents/RequestGroupTestSession/RequestTestSession'
import { RequestTestSession as RequestBasicTestSession } from 'sharedComponents/RequestTestSession'

interface RouterProps {
  groupId?: string
  companyId?: string
}

type Props = RouteComponentProps<RouterProps>

const RequestTestSession: React.VFC<Props> = ({ match, history }) => {
  const { companyId, groupId } = match.params
  const handleGroupRequestSuccess = React.useCallback(() => {
    history.push(`/${ROUTES.COMPANIES}/${String(companyId)}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId])

  return (
    <DashboardPage>
      <Container>
        <Card>
          <Card.Title>{groupId ? 'Group Test Session Form' : 'Test Session Form'}</Card.Title>
          <Card.Content>
            {groupId && companyId ? (
              <RequestGroupTestSession
                companyId={companyId}
                onRequestSuccess={handleGroupRequestSuccess}
                groupId={groupId}
                minHoursBeforeBooking={AppointmentBookingHours.ADMIN}
                showInsuranceOptions
              />
            ) : (
              <RequestBasicTestSession
                minHoursBeforeBooking={AppointmentBookingHours.ADMIN}
                showInsuranceOptions
              />
            )}
          </Card.Content>
        </Card>
      </Container>
    </DashboardPage>
  )
}

export default RequestTestSession
